var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "bg-white border-none overflow-hidden sm:rounded-sm mb-3 infoCard mt-0",
      class: _vm.dark ? "md:rounded-xl" : "",
    },
    [
      _c(
        "div",
        {
          staticClass: "flex text-gray-800",
          class: _vm.contentHorizontalPadding,
        },
        [
          _vm._t("prefix", function () {
            return [_c("p", [_vm._v(" " + _vm._s(_vm.prefix) + " ")])]
          }),
          _c(
            "div",
            { staticClass: "w-full text-gray-800 pt-1 pb-1" },
            [
              _vm._t("default", function () {
                return [
                  _vm.content
                    ? _c("p", { staticClass: "truncate" }, [
                        _vm._v(" " + _vm._s(_vm.content) + " "),
                      ])
                    : _c("p", { staticClass: "text-gray-400" }, [
                        _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                      ]),
                ]
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }